export const API_BASE_URL = import.meta.env.VITE_OS_BLOCKS_API_URL
export const X_BLOCKS_KEY = import.meta.env.VITE_OS_BLOCKS_X_BLOCKS_KEY
